const isA404Error = error => {
  return error instanceof Response && error.status === 404
}
export {
  isA404Error
}
